import { StringContext } from "../../core/StringContext";
import { StringModule } from "../../core/StringModule";

/**
 * Represents a module responsible for handling loading-related functionality.
 * Extends the `StringModule` class and provides additional behavior for managing
 * loading states and timeouts.
 */
export class StringLoading extends StringModule {
  loadingTimeout: number = 0;

  constructor(context: StringContext) {
    super(context);
    this._type = 2;
    this.loadingTimeout = this.settings["timeout"];
  }
  onInit(): void {
    setTimeout(() => {
      const htmlElement = document.documentElement;
      htmlElement.classList.add("-loaded");
    }, this.loadingTimeout);
  }
}
